import React from 'react'

const Action = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg
    fill={fill}
    width={width}
    height={height}
    {...props}
    viewBox='5 5 49 49'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <text fontSize='14' fontWeight='bold'>
      <tspan x='4.922' y='51.923'>
        In action
      </tspan>
    </text>
    <path
      d='M35.341 12.296h6.362c.46 0 .832.387.824.86l-.137 8.149a.834.834 0 0 1-.839.83.835.835 0 0 1-.81-.86l.123-7.29h-5.523v1.744a.5.5 0 0 1-.494.507.485.485 0 0 1-.225-.056l-5.014-2.617a.513.513 0 0 1-.001-.902l5.014-2.638a.489.489 0 0 1 .666.22c.036.071.054.15.054.23v1.823zm-18.69 20.036h.875c.455 0 .824.378.824.844 0 .466-.37.844-.824.844h-1.702a.835.835 0 0 1-.824-.846l.065-25.332A.834.834 0 0 1 15.89 7h10.975c.455 0 .824.378.824.844v13.624a.835.835 0 0 1-.824.845.835.835 0 0 1-.824-.845V8.688h-9.33l-.06 23.644zm27.808-8.11c.466 0 .842.37.842.824V36.02a.835.835 0 0 1-.844.824H20.814a.835.835 0 0 1-.844-.824V24.98c0-.457.379-.826.846-.825l23.643.065zm-22.8 1.585v9.39h21.953v-9.33l-21.954-.06z'
      fillRule='nonzero'
    />
  </svg>
)

export default Action
